const districts = [
  "Ilala - Dar es Salaam",
  "Kinondoni - Dar es Salaam",
  "Temeke - Dar es Salaam",
  "Ubungo - Dar es Salaam",
  "Kigamboni - Dar es Salaam",

  "Ilemela - Mwanza",
  "Nyamagana - Mwanza",
  "Sengerema - Mwanza",
  "Magu - Mwanza",
  "Kwimba - Mwanza",
  "Ukerewe - Mwanza",
  "Misungwi - Mwanza",

  "Arusha - Arusha",
  "Arumeru - Arusha",
  "Karatu - Arusha",
  "Longido - Arusha",
  "Monduli - Arusha",
  "Ngorongoro - Arusha",

  "Dodoma - Dodoma",
  "Bahi - Dodoma",
  "Chamwino - Dodoma",
  "Chemba - Dodoma",
  "Kondoa - Dodoma",
  "Kongwa - Dodoma",
  "Mpwapwa - Dodoma",

  "Morogoro - Morogoro",
  "Kilosa - Morogoro",
  "Kilombero - Morogoro",
  "Mvomero - Morogoro",
  "Ulanga - Morogoro",
  "Malinyi - Morogoro",
  "Gairo - Morogoro",

  "Iringa - Iringa",
  "Kilolo - Iringa",
  "Mufindi - Iringa",

  "Mbeya - Mbeya",
  "Chunya - Mbeya",
  "Kyela - Mbeya",
  "Mbarali - Mbeya",
  "Rungwe - Mbeya",
  "Busokelo - Mbeya",

  "Tanga - Tanga",
  "Handeni - Tanga",
  "Kilindi - Tanga",
  "Korogwe - Tanga",
  "Lushoto - Tanga",
  "Muheza - Tanga",
  "Mkinga - Tanga",
  "Pangani - Tanga",

  "Sumbawanga - Rukwa",
  "Nkasi - Rukwa",
  "Kalambo - Rukwa",

  "Tabora - Tabora",
  "Igunga - Tabora",
  "Kaliua - Tabora",
  "Nzega - Tabora",
  "Sikonge - Tabora",
  "Urambo - Tabora",
  "Uyui - Tabora",

  "Shinyanga - Shinyanga",
  "Kahama - Shinyanga",
  "Kishapu - Shinyanga",
  "Shinyanga Rural - Shinyanga",

  "Geita - Geita",
  "Bukombe - Geita",
  "Chato - Geita",
  "Mbogwe - Geita",
  "Nyang'hwale - Geita",

  "Kigoma - Kigoma",
  "Kasulu - Kigoma",
  "Kakonko - Kigoma",
  "Kibondo - Kigoma",
  "Uvinza - Kigoma",

  "Katavi - Katavi",
  "Mpanda - Katavi",
  "Mlele - Katavi",

  "Songea - Ruvuma",
  "Mbinga - Ruvuma",
  "Namtumbo - Ruvuma",
  "Nyasa - Ruvuma",
  "Tunduru - Ruvuma",

  "Mtwara - Mtwara",
  "Masasi - Mtwara",
  "Nanyumbu - Mtwara",
  "Newala - Mtwara",
  "Tandahimba - Mtwara",

  "Lindi - Lindi",
  "Kilwa - Lindi",
  "Liwale - Lindi",
  "Nachingwea - Lindi",
  "Ruangwa - Lindi",

  "Singida - Singida",
  "Iramba - Singida",
  "Ikungi - Singida",
  "Manyoni - Singida",
  "Mkalama - Singida",

  "Kagera - Kagera",
  "Bukoba - Kagera",
  "Biharamulo - Kagera",
  "Karagwe - Kagera",
  "Kyerwa - Kagera",
  "Missenyi - Kagera",
  "Muleba - Kagera",
  "Ngara - Kagera",
];

export default districts;
